var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-container',{ref:"elementBox",staticClass:"landing-page-element"},[_c('el-header',{staticClass:"landing-page-element-title"},[_vm._t("element-title")],2),_vm._t("element-content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }